import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  Achievement,
  Nullable,
  UserAchievement,
  UserWithToken,
  WithData,
} from '@ygoargentina/sdk/api/api.types';

const ACHIEVEMENT_FIELDS = gql`
  fragment AchievementFields on Achievement {
    id
    key
    name
    description
    category
    iconUrl
    xpReward
    isHidden
    requirement
    createdAt
  }
`;

const USER_ACHIEVEMENT_FIELDS = gql`
  ${ACHIEVEMENT_FIELDS}
  fragment UserAchievementFields on UserAchievement {
    id
    userId
    achievementId
    unlockedAt
    achievement {
      ...AchievementFields
    }
  }
`;

export const getAchievements = async (
  user: Nullable<UserWithToken>,
  includeHidden = false,
  category?: string
) =>
  getGraphQLQueryClient(user).request<WithData<Achievement[]>>(
    gql`
      ${ACHIEVEMENT_FIELDS}
      query achievements($includeHidden: Boolean, $category: AchievementCategory) {
        data: achievements(includeHidden: $includeHidden, category: $category) {
          ...AchievementFields
        }
      }
    `,
    { includeHidden, category: category ?? null }
  );

export const getMyAchievements = async (user: UserWithToken) =>
  getGraphQLQueryClient(user).request<WithData<UserAchievement[]>>(
    gql`
      ${USER_ACHIEVEMENT_FIELDS}
      query myAchievements {
        data: myAchievements {
          ...UserAchievementFields
        }
      }
    `
  );

export const getUserAchievements = async (
  user: Nullable<UserWithToken>,
  userId: number
) =>
  getGraphQLQueryClient(user).request<WithData<UserAchievement[]>>(
    gql`
      ${USER_ACHIEVEMENT_FIELDS}
      query userAchievements($userId: Int!) {
        data: userAchievements(userId: $userId) {
          ...UserAchievementFields
        }
      }
    `,
    { userId }
  );

export const grantAchievement = async (
  user: UserWithToken,
  userId: number,
  achievementKey: string
) =>
  getGraphQLQueryClient(user).request<WithData<UserAchievement>>(
    gql`
      ${USER_ACHIEVEMENT_FIELDS}
      mutation grantAchievement($userId: Int!, $achievementKey: String!) {
        data: grantAchievement(userId: $userId, achievementKey: $achievementKey) {
          ...UserAchievementFields
        }
      }
    `,
    { userId, achievementKey }
  );
